import { Badge } from '@capawesome/capacitor-badge';
import { getSupabaseClient } from '@/api/supabaseClient';

const PUSH_DEVICE_TOKEN_STORAGE_KEY = 'mbv_push_device_token';

function isNativePlatform() {
  if (typeof window === 'undefined') return false;
  if (typeof window.Capacitor?.isNativePlatform === 'function') {
    return window.Capacitor.isNativePlatform();
  }
  return false;
}

function isNotificationUnread(notification = {}) {
  if (notification.is_read === true) return false;
  if (String(notification.is_read).toLowerCase() === 'true') return false;
  return true;
}

async function countUnreadNotifications({ user, member }) {
  const normalizedEmail = String(member?.email || user?.email || '').trim().toLowerCase();
  const memberId = member?.id || null;
  if (!normalizedEmail && !memberId) return 0;

  const supabase = getSupabaseClient();
  const notificationsById = new Map();

  const addRows = (rows = []) => {
    rows.forEach((row) => {
      notificationsById.set(row.id, {
        id: row.id,
        ...(row.data || {}),
      });
    });
  };

  if (normalizedEmail) {
    const { data, error } = await supabase
      .from('notifications')
      .select('id, data')
      .eq('data->>member_email', normalizedEmail)
      .order('created_date', { ascending: false })
      .limit(500);

    if (error) throw new Error(`Falha ao contar notificacoes: ${error.message}`);
    addRows(data);
  }

  if (memberId) {
    const { data, error } = await supabase
      .from('notifications')
      .select('id, data')
      .eq('data->>member_id', memberId)
      .order('created_date', { ascending: false })
      .limit(500);

    if (error) throw new Error(`Falha ao contar notificacoes: ${error.message}`);
    addRows(data);
  }

  return [...notificationsById.values()].filter(isNotificationUnread).length;
}

export async function setAppIconBadge(count) {
  if (!isNativePlatform()) return false;

  try {
    const support = await Badge.isSupported();
    if (!support?.isSupported) return false;

    const permissions = await Badge.checkPermissions().catch(() => ({ display: 'granted' }));
    if (permissions?.display === 'denied') return false;
    if (permissions?.display === 'prompt' || permissions?.display === 'prompt-with-rationale') {
      const requested = await Badge.requestPermissions().catch(() => permissions);
      if (requested?.display === 'denied') return false;
    }

    const safeCount = Math.max(0, Number(count) || 0);
    if (safeCount === 0) {
      await Badge.clear();
    } else {
      await Badge.set({ count: safeCount });
    }
    return true;
  } catch (error) {
    console.warn('[badge] falha ao atualizar badge do icone', error);
    return false;
  }
}

export async function clearAppIconBadge() {
  const cleared = await setAppIconBadge(0);

  try {
    const supabase = getSupabaseClient();
    await supabase.rpc('mark_push_badge_seen', {
      p_device_token: localStorage.getItem(PUSH_DEVICE_TOKEN_STORAGE_KEY) || null,
    });
  } catch (error) {
    console.warn('[badge] falha ao registrar limpeza do badge no Supabase', error);
  }

  return cleared;
}

export async function syncAppIconBadge({ user, member }) {
  const unreadCount = await countUnreadNotifications({ user, member });
  await setAppIconBadge(unreadCount);
  return unreadCount;
}
